var React = require('react');

function Person (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},".st0{fill:none;stroke:#000000;stroke-width:0.9;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#000000;stroke-miterlimit:10;}"),React.createElement("circle",{"cx":"8","cy":"5","r":"4.5","key":1}),React.createElement("path",{"d":"M0.5,18.5v-3.75c0-1.24,1.01-2.25,2.25-2.25h10.5c1.24,0,2.25,1.01,2.25,2.25v3.75","key":2})]);
}

Person.defaultProps = {"version":"1.1","x":"0px","y":"0px","width":"16px","height":"19px","viewBox":"0 0 16 19","style":{"enableBackground":"new 0 0 16 19"},"xmlSpace":"preserve"};

module.exports = Person;

Person.default = Person;
